import { handleTrack } from '../../../../../utils/tracker';

export const LuxuryTaxSupport = (dataObj: {
  heading_1: string;
  description: string[];
  price: string;
  utm_ref: string;
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    handleTrack({
      label: 'showcase-fold_',
      obj: e.target,
      value: `https://cleartax.in/checkout/prod_itr_af_luxury?utm_ref=${dataObj.utm_ref}`,
    });
    window.location.href = `https://cleartax.in/checkout/prod_itr_af_luxury?utm_ref=${dataObj.utm_ref}`;
  };

  return (
    <div
      className="border-sm border-yellow-500 rounded-3xl flex justify-between sm:flex-col-reverse my-16 text-black hover:cursor-pointer"
      onClick={handleClick}
    >
      <div className="left px-14 py-8 bg-[url('https://assets.clear.in/cleartax/images/1746007827_bgluxuryfiling.svg')] w-1/2 sm:w-full sm:px-6 sm:rounded-bl-3xl rounded-br-3xl">
        <div className="text-s-32 font-extrabold leading-8 tracking-normal sm:pt-6 max-w-[313px]">
          {dataObj.heading_1}
        </div>
        <ul className="pt-6">
          {dataObj.description.map((item, index) => (
            <li key={index} className="flex items-start">
              <img src="https://assets.clear.in/cleartax/images/1746011699_checkcircle.svg" />
              {item}
            </li>
          ))}
        </ul>
        <div
          className="text-s-32 font-extrabold py-7 pb-12 sm:pb-6"
          id="luxury-support-price"
        >
          {dataObj.price}
          <span className="text-base font-medium text-gray-400 pl-2">
            Onwards
          </span>
        </div>
        <div className="flex sm:flex-col sm:gap-6 items-center">
          <a
            id="luxury-support-buy-now"
            className="bg-gray-800 font-bold text-base py-3 px-16 text-white rounded-md text-center sm:w-full"
            href={`https://cleartax.in/checkout/prod_itr_af_luxury?utm_ref=${dataObj.utm_ref}`}
            onClick={(e) => {
              e.stopPropagation(); // Stop event from bubbling up to parent div
              handleTrack({
                label: 'showcase-fold_',
                obj: e.target,
                value: `https://cleartax.in/checkout/prod_itr_af_luxury?utm_ref=${dataObj.utm_ref}`,
              });
            }}
          >
            Buy Now
          </a>{' '}
          <a
            id="luxury-support-know-more"
            className="text-base font-bold px-6 text-center flex gap-2 text-black"
            href={`https://cleartax.in/services/prod_itr_af_luxury/p?utm_ref=${dataObj.utm_ref}`}
            target="_blank"
            onClick={(e) => {
              e.stopPropagation(); // Stop event from bubbling up to parent div
              handleTrack({
                label: 'showcase-fold_',
                obj: e.target,
                value: `https://cleartax.in/services/prod_itr_af_luxury/p?utm_ref=${dataObj.utm_ref}`,
              });
            }}
            rel="noreferrer"
          >
            Know More{' '}
            <img
              className="pt-0.25"
              src="https://assets.clear.in/cleartax/images/1746015148_vector.svg"
            />
          </a>
        </div>
      </div>
      <div className="right rounded-3xl w-1/2 sm:w-full relative">
        <img
          className="absolute bottom-0 transform -translate-x-1/2 translate-y-0 sm:translate-x-0 sm:translate-y-1/2 sm:h-40"
          src="https://assets.clear.in/cleartax/images/1746006413_group1814222381.svg"
        />
        <img
          className="rounded-3xl rounded-tl-none rounded-bl-none h-full object-cover sm:w-full sm:h-52 sm:rounded-tl-3xl sm:rounded-br-none"
          src="https://assets.clear.in/cleartax/images/1746006479_freepik__twoindianbusinessprofessionalsacaucasianwoma__486381.svg"
        />
      </div>
    </div>
  );
};
